import { render, staticRenderFns } from "./FeeWizardModal.vue?vue&type=template&id=6b12d716&scoped=true&"
import script from "./FeeWizardModal.vue?vue&type=script&lang=js&"
export * from "./FeeWizardModal.vue?vue&type=script&lang=js&"
import style0 from "./FeeWizardModal.vue?vue&type=style&index=0&id=6b12d716&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b12d716",
  null
  
)

component.options.__file = "FeeWizardModal.vue"
export default component.exports